import { render } from "./TagButton.vue?vue&type=template&id=461e996c&scoped=true"
import script from "./TagButton.vue?vue&type=script&lang=js"
export * from "./TagButton.vue?vue&type=script&lang=js"

import "./TagButton.vue?vue&type=style&index=0&id=461e996c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461e996c"],['__file',"src/components/TagButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "461e996c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('461e996c', __exports__)) {
    api.reload('461e996c', __exports__)
  }
  
  module.hot.accept("./TagButton.vue?vue&type=template&id=461e996c&scoped=true", () => {
    api.rerender('461e996c', render)
  })

}


export default __exports__